import moment from 'moment';
export function getDate(startTimes, endTimes) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
    end.setTime(end.getTime());
    const startTime = moment(start).format('YYYY-MM-DD ') + startTimes;
    const endTime = moment(end).format('YYYY-MM-DD ') + endTimes;
    return [startTime, endTime];
}
